import MapSectionImplementation from '../implementation/sections/MapSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiMapSectionDTO,
  MapSectionDTO,
} from '@lib/strapi/dtos/components/sections/mapSection.dto';

const MapSection = (props: ComponentProps<MapSectionDTO>) => {
  return <MapSectionImplementation {...props}></MapSectionImplementation>;
};

export default MapSection;
